import React, { useState, useEffect} from 'react';
import "./footer.scss";
import {faTwitter, faFacebookF, faLinkedinIn, faInstagram, faYoutube} from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
config.autoAddCss = false

const Footer = (props) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const thisYear =  new Date().getFullYear();

  useEffect(() => {
      const fetchData = async () => {
        //setIsError(false)
          setIsLoading(true)
      try {
          const result = await axios(process.env.MET_FOOTER)
          //let test =result.data.footer
          //test.sort(compare);
          setData(result.data.footer);
          setIsLoading(false)
          //console.log(result.data.footer);
      } catch (error) {
          setIsError(true);
          console.log(error);
      }
          //setIsLoading(false)
      }
      fetchData();
  },[])

  // function compare(a, b) {
  //   let comparison = 0;
  //   if (a.SortOrder > b.SortOrder) {
  //     comparison = 1;
  //   } else if (a.SortOrder < b.SortOrder) {
  //     comparison = -1;
  //   }
  //   return comparison;
  // }

  if (isLoading) return <div></div>;
  if (isError) return <div></div>;
  return (
    <React.Fragment>
    <footer>
      <div id="footerSpace"> 
          <div> 
              <div>
              <dl>
                  <dt className="socialHeaderMobile">Find us on social media</dt>
                  <dd className="socialHeader">Find us on social media</dd>
                  <dd className="fontawesomeHover" style={{marginLeft:"0"}}>
                  <a className="fontawesomepadding socialIconFocus" title="Twitter opens in new window" href="https://twitter.com/govjersey" target="_blank" rel="noreferrer">
                    <span  className="fa-layers fa-fw">
                      <FontAwesomeIcon className="fontawesomeCircle" icon={faCircle} />
                      <FontAwesomeIcon style={{fontSize:"29px", left:"2px"}} icon={faTwitter}  inverse transform="shrink-6" />
                    </span>
                  </a>      
                  </dd>
                  <dd>
                  <a className="fontawesomepadding socialIconFocus" title="LinkedIn opens in new window"  href="https://www.linkedin.com/company/government-of-jersey" target="_blank" rel="noreferrer">
                    <span className="fa-layers fa-fw">
                      <FontAwesomeIcon className="fontawesomeCircle" icon={faCircle} />
                      <FontAwesomeIcon style={{fontSize:"29px", left:"4px"}} icon={faLinkedinIn}  inverse transform="shrink-6" />
                    </span>
                  </a>      
                  </dd>
                  <dd>
                  <a className="fontawesomepadding socialIconFocus" title="Facebook opens in new window"  href="https://www.facebook.com/GovernmentofJersey" target="_blank" rel="noreferrer">
                    <span className="fa-layers fa-fw">
                      <FontAwesomeIcon className="fontawesomeCircle" icon={faCircle} />
                      <FontAwesomeIcon style={{fontSize:"29px", left:"6px"}} icon={faFacebookF}  inverse transform="shrink-6" />
                    </span>
                  </a>      
                  </dd>
                  <dd>
                  <a className="fontawesomepadding socialIconFocus" title="Instagram opens in new window"  href="https://www.instagram.com/governmentofjersey/" target="_blank" rel="noreferrer">
                    <span className="fa-layers fa-fw">
                      <FontAwesomeIcon className="fontawesomeCircle" icon={faCircle} />
                      <FontAwesomeIcon style={{fontSize:"29px", left:"4px"}} icon={faInstagram}  inverse transform="shrink-6" />
                    </span>
                  </a>      
                  </dd>
                  <dd>
                  <a className="socialIconFocus" title="YouTube opens in new window"  href="https://www.youtube.com/governmentofjersey" target="_blank" rel="noreferrer">
                    <span className="fa-layers fa-fw">
                      <FontAwesomeIcon className="fontawesomeCircle" icon={faCircle} />
                      <FontAwesomeIcon style={{fontSize:"29px"}} icon={faYoutube}  inverse transform="shrink-6" />
                    </span>
                  </a>      
                  </dd>
                </dl>
              </div>
          </div>
          <div>
              <div id="footerMargin">
                  <ul className="footerLinks">
                      {data.map((result, index) => 
                        <li key={index} dangerouslySetInnerHTML={{__html: result.GovJEHtmlLinkUrl}} ></li>
                      )} 
                      <li id="watermark" className="right">© Government of Jersey 2010 - {thisYear}</li>
                  </ul>
              </div>
          </div>
      </div>
    </footer>
    </React.Fragment>
  )
}
export default Footer
